module.exports = __webpack_public_path__ + "static/img/price-blue.6a8a6eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price-blue.png
// module id = hTx2
// module chunks = 0